﻿import { Component, Input, HostBinding } from '@angular/core';

@Component({
    selector: 'inline-loading',
    templateUrl: './inline-loading.component.html',
    styleUrls: ['./inline-loading.component.css']
})
export class InlineLoadingComponent {
    @Input() show: boolean = true;
}